import { LockOutlined } from "@ant-design/icons";
import { Button, Modal, Typography } from "antd";

import { FOOTER_CONTACT } from "@/constants";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setAccountLockedVisible } from "@/store/auth.slice";

const { Paragraph, Text, Title } = Typography;

export const AccountLockedModal = () => {
  const dispatch = useAppDispatch();
  const open = useAppSelector((state) => state.auth.showAccountLocked);

  const handleClose = () => {
    dispatch(setAccountLockedVisible(false));
  };

  return (
    <Modal
      centered
      closable={false}
      footer={null}
      open={open}
      onCancel={handleClose}
      width={420}
    >
      <div className="account-locked-modal">
        <div className="account-locked-modal__icon" aria-hidden="true">
          <LockOutlined />
        </div>
        <Title level={4} style={{ marginBottom: 8 }}>
          Tài khoản đang bị khóa
        </Title>
        <Paragraph type="secondary">
          Vui lòng liên hệ hotline <Text strong>{FOOTER_CONTACT.phone}</Text> để
          được hỗ trợ mở khóa tài khoản.
        </Paragraph>
        <Button block type="primary" onClick={handleClose}>
          Đã hiểu
        </Button>
      </div>
    </Modal>
  );
};
